import { render } from "./DropdownSingleIcon.vue?vue&type=template&id=18fe9c46&ts=true"
import script from "./DropdownSingleIcon.vue?vue&type=script&lang=ts"
export * from "./DropdownSingleIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__